<template>
  <div v-if="isLoaded">
    <div class="b-page__title-wrap py-4 px-6">
      <h1>{{ $t('CONTENT.contract.create_alt_contract') }}</h1>
    </div>
    <server-error :error="error" />
    <div class="b-page__content mt-6 mx-6">
      <form class="k-form_type_contract b-form p-0 pb-8">
        <AlternativeContract
          :validation-errors="validationErrors"
          :validation-period-spendings="validationPeriodSpendings"
          :validation-low-value-asset="validationLowValueAsset"
        />
        <div class="mt-10 b-form__container b-form__container_type_flex">
          <button
            class="b-btn b-btn_type_primary b-btn_type_save"
            type="submit"
            data-cy="next-step"
            @click.prevent="onSubmit"
          >
            {{ $t('CONTENT.save') }}
          </button>
          <button
            class="b-btn b-btn_type_empty b-btn_type_save"
            data-cy="set-next-step"
            @click="$router.push({name: 'Contracts'})"
          >
            {{ $t('CONTENT.cancel') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AlternativeContractModel from '../models/alternativeContract/AlternativeContract';
import AlternativeContract from '../components/registry/alternativeContracts/AlternativeContract';

export default {
  components: {
    AlternativeContract,
  },
  data() {
    return {
      formData: null,
      error: null,
      validationErrors: [],
      validationPeriodSpendings: [],
      validationLowValueAsset: [],
    };
  },
  async created() {
    try {
      this.$loadingManager.addLoadingStep();
      await Promise.all([
        this.$store.dispatch('getAllCounterparties'),
        this.$store.dispatch('loadContractSettings'),
        this.$store.dispatch('getAllCounterpartyAddressTypes'),
        this.$store.dispatch('getAllDirectoryLegalForms'),
        this.$store.dispatch('getAllCounterpartyTypes'),
        this.$store.dispatch('loadAllUnderlyingAssetTypes'),
        this.$store.dispatch('loadAllBusinessUnits'),
        this.$store.dispatch('loadAllAssets'),
      ]);
      this.formData = AlternativeContractModel.createNew();

      for (const prop in this.currentAlternativeKinds) {
        if (this.currentAlternativeKinds.hasOwnProperty(prop)) {
          this.formData[prop] = this.currentAlternativeKinds[prop];
        }
      }

      this.$store.commit('SET_CURRENT_ALTERNATIVE_CONTRACT', this.formData);
      this.$loadingManager.loadingStepLoaded();
    } catch (e) {
      this.$loadingManager.hideLoadScreen();
      this.error = e;
    }
  },
  computed: {
    ...mapGetters(['getAlternativeKinds']),
    currentAlternativeKinds() {
      return this.getAlternativeKinds;
    },
  },
  methods: {
    async onSubmit() {
      try {
        if (!this.validate()) return;
        this.$loadingManager.addLoadingStep();
        await this.$store.dispatch('createAlternativeContract');
        this.$loadingManager.loadingStepLoaded();
        this.$router.push('/registry/contracts');
      } catch (e) {
        this.$loadingManager.hideLoadScreen();
        this.error = e;
      }
    },
    validate() {
      this.validationErrors = [];
      this.validationPeriodSpendings = [];
      const contract = this.$store.getters.getCurrentAlternativeContract;

      if (!contract.number) {
        this.validationErrors.push('number');
      }
      if (!contract.date) {
        this.validationErrors.push('date');
      }
      if (!contract.lesseeId) {
        this.validationErrors.push('currentLessee');
      }
      if (!this.arrayIsNotEmpty(contract.lessorIds)) {
        this.validationErrors.push('lessor');
      }
      if (contract.isLowValue) {
        this.validateLowValueAssets(contract.lowValueAssets);
        return this.validationErrors.length <= 0 && !this.validationLowValueAsset.some(e => e.assetId || e.periodSpendings.some(p => p.length > 0));
      }

      if (!contract.isExceptionToArticle3OfIFRS16 && !contract.isIrrelevant && !contract.isLowValue
        && !contract.isShortTerm && !contract.isVariableLeasePayments && !contract.isNotRentContract) {
        this.validationErrors.push('typeException');
      }

      this.validatePeriodSpendings(contract.periodSpendings);
      return this.validationErrors.length <= 0 && !this.validationPeriodSpendings.some(e => e.length > 0);
    },
    validatePeriodSpendings(periodSpendings) {
      this.validationPeriodSpendings = [];
      for (const [index, periodSpending] of periodSpendings.entries()) {
        this.$set(this.validationPeriodSpendings, index, []);
        if (!periodSpending.startDate) {
          this.validationPeriodSpendings[index].push('startDate');
        }
        if (!periodSpending.endDate) {
          this.validationPeriodSpendings[index].push('endDate');
        }
        if (periodSpending.sum === null || periodSpending.sum === undefined) {
          this.validationPeriodSpendings[index].push('sum');
        }
      }
      return this.validationPeriodSpendings;
    },
    validateLowValueAssets(lowValueAssets) {
      this.validationLowValueAsset = [];
      for (const lowValueAsset of lowValueAssets) {
        this.validationLowValueAsset.push({ assetId: !lowValueAsset.assetId, periodSpendings: this.validatePeriodSpendings(lowValueAsset.periodSpendings) });
      }
    },
    arrayIsNotEmpty(array) {
      return Array.isArray(array) && array.length > 0 && array.every(a => !!a);
    },
  },
};
</script>
